import React from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import LiveSection from "../components/LiveSection";
import About from "../components/About";
import Programs from "../components/Programs";
import Coaches from "../components/Coaches";
import Schedule from "../components/Schedule";
import Gallery from "../components/Gallery";
import News from "../components/News";
import InstagramFeed from "../components/InstagramFeed";
import Registration from "../components/Registration";
import Footer from "../components/Footer";
import { SettingsProvider } from "../context/SettingsContext";

export default function Home() {
  return (
    <SettingsProvider>
      <div className="bg-background">
        <Navbar />
        <Hero />
        <LiveSection />
        <About />
        <Programs />
        <Coaches />
        <Schedule />
        <Gallery />
        <News />
        <InstagramFeed />
        <Registration />
        <Footer />
      </div>
    </SettingsProvider>
  );
}
